
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Katrajtomumbaicab() {



    const cardData =
    {
        keyword: 'Katraj to Mumbai Cab Service',
        heading: 'Skyline Cabs: Katraj to Mumbai Cab Service',
        headingDescription: 'Skyline Cabs provides reliable and affordable Katraj to Mumbai Cab Service for a smooth and stress-free journey. Whether you are traveling for business, leisure, or an airport drop, our professional drivers and well-maintained fleet ensure on-time and comfortable rides. With transparent pricing, round-the-clock availability, and excellent customer support, Skyline Cabs is your trusted travel partner from Katraj to Mumbai. Book your cab today and enjoy a convenient ride at the best rates.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Katraj to Mumbai Airport Cab Fare",
      "description": "Skyline Cabs provides transparent and affordable taxi services from Katraj to Mumbai Airport. With options like Innova and Ertiga, we ensure a comfortable ride and on-time arrival."
    },
    {
      "name": "Katraj to Mumbai Navi Mumbai Cab",
      "description": "Skyline Cabs offers reliable and affordable taxi services from Katraj to Navi Mumbai. We provide a variety of vehicles, including Innova and Ertiga, for a smooth and comfortable journey."
    },
    {
      "name": "Ambegaon Pune to Mumbai Cab",
      "description": "Book a hassle-free ride from Ambegaon Pune to Mumbai with Skyline Cabs. We offer a variety of vehicles like Innova, Ertiga, and Sedan for a comfortable and punctual trip."
    },
    {
      "name": "Ambegaon Budruk to Mumbai Airport Cab",
      "description": "Skyline Cabs offers prompt and professional taxi services from Ambegaon Budruk to Mumbai Airport. Choose from a range of vehicles like Innova and Ertiga for a comfortable and timely airport transfer."
    },
    {
      "name": "Dhayari to Mumbai Cab",
      "description": "Travel conveniently from Dhayari to Mumbai with Skyline Cabs. We provide affordable and reliable taxi services, including options like Innova and Ertiga for a comfortable ride."
    },
    {
      "name": "Mukund Nagar to Mumbai Cab",
      "description": "Skyline Cabs offers convenient and comfortable taxi services from Mukund Nagar to Mumbai. Choose from a variety of vehicles for a smooth journey to your destination."
    },
    {
      "name": "Parvati to Mumbai Cab",
      "description": "Skyline Cabs offers reliable and timely taxi services from Parvati to Mumbai. Whether you're traveling for business or leisure, our fleet of vehicles ensures a comfortable ride."
    },
    {
      "name": "Sinhagad Road to Mumbai Cabs",
      "description": "Skyline Cabs provides reliable taxi services from Sinhagad Road to Mumbai. With vehicles like Innova and Ertiga, we ensure your journey is comfortable and punctual."
    },
    {
      "name": "Katraj to Mumbai One Way Cab",
      "description": "For a one-way trip from Katraj to Mumbai, Skyline Cabs offers convenient and affordable taxi services. Choose from various vehicles, ensuring comfort and punctuality throughout your journey."
    },
    {
      "name": "Dhayari to Mumbai Taxi Service",
      "description": "Skyline Cabs offers prompt taxi services from Dhayari to Mumbai. With options like Innova and Ertiga, we ensure a safe and comfortable ride for your journey."
    },
    {
      "name": "Cab Service in Katraj",
      "description": "Skyline Cabs provides a variety of reliable taxi services in Katraj, Pune. Whether you need a local trip or a ride to Mumbai, we offer comfortable vehicles and professional drivers."
    },
    {
      "name": "Online Cab Booking in Katraj",
      "description": "Easily book your cab online with Skyline Cabs in Katraj. Our user-friendly platform lets you choose from a variety of vehicles for your ride, ensuring comfort and reliability."
    },
    {
      "name": "Book Safe & Reliable Cabs in Katraj",
      "description": "Skyline Cabs offers safe and reliable taxi services in Katraj, Pune. Book a cab for local or long-distance travel with our fleet of well-maintained vehicles and professional drivers."
    },
    {
      "name": "Innova Crysta on Rent in Katraj Pune",
      "description": "Skyline Cabs offers Innova Crysta rentals in Katraj, Pune. Ideal for family trips, group travel, or business purposes, the Innova Crysta offers comfort, space, and style for a smooth ride."
    },
    {
      "name": "Ertiga on Rent in Katraj",
      "description": "Skyline Cabs offers Ertiga rentals in Katraj, Pune. Perfect for families or small groups, the Ertiga provides ample space and comfort for your travels to Mumbai or other destinations."
    },
    {
      "name": "Sedan Car on Rent in Katraj",
      "description": "Skyline Cabs offers sedan rentals in Katraj, Pune. Choose from a range of sedan vehicles like Swift Dzire or Etios for a comfortable and affordable ride."
    },
    {
      "name": "Katraj to Mumbai Airport Cabs",
      "description": "Skyline Cabs offers efficient and reliable airport transfer services from Katraj to Mumbai Airport. We provide a variety of vehicles, including luxury options like Innova Crysta and Ertiga, for a smooth and timely journey."
    },
    {
      "name": "Katraj to Dadar Cabs",
      "description": "Skyline Cabs provides affordable and comfortable taxi services from Katraj to Dadar. With vehicles like Innova, Ertiga, and Sedan, you’ll enjoy a smooth and punctual ride."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs offers reliable taxi services throughout Pune. Whether you're traveling locally or need a ride to Mumbai, we offer well-maintained vehicles and professional drivers."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers convenient and timely taxi services from Pune to Mumbai Airport. Our fleet includes options like Innova and Ertiga, ensuring a comfortable and reliable airport transfer."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs provides reliable and affordable taxi services between Pune and Mumbai. Whether you need a one-way trip or a round trip, we offer a variety of vehicles to meet your needs."
    },
    {
      "name": "Cab Service in Katraj Pune",
      "description": "Skyline Cabs offers dependable taxi services in Katraj, Pune. From local trips to long-distance travel, our fleet of well-maintained vehicles ensures a safe and comfortable ride."
    }
  ],
  "tableData": [
    ["Katraj to Mumbai Airport Cab Fare", "Katraj to Mumbai Navi Mumbai Cab"],
    ["Ambegaon Pune to Mumbai Cab", "Ambegaon Budruk to Mumbai Airport Cab"],
    ["Dhayari to Mumbai Cab", "Mukund Nagar to Mumbai Cab"],
    ["Parvati to Mumbai Cab", "Sinhagad Road to Mumbai Cabs"],
    ["Katraj to Mumbai One Way Cab", "Dhayari to Mumbai Taxi Service"],
    ["Cab Service in Katraj", "Online Cab Booking in Katraj"],
    ["Book Safe & Reliable Cabs in Katraj", "Innova Crysta on Rent in Katraj Pune"],
    ["Ertiga on Rent in Katraj", "Sedan Car on Rent in Katraj"],
    ["Katraj to Mumbai Airport Cabs", "Katraj to Dadar Cabs"],
    ["Cab Service in Pune", "Pune to Mumbai Airport Cab"],
    ["Pune Mumbai Cab", "Cab Service in Katraj Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Katraj to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides trustworthy and timely cab services from Katraj to Mumbai, ensuring you reach your destination without delay. Whether it’s for business, leisure, or catching a flight, you can count on us for a hassle-free and punctual ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet of vehicles, including sedans, SUVs, and luxury cars, are designed for comfort and space. With clean interiors, air-conditioning, and ample legroom, enjoy a smooth and comfortable ride from Katraj to Mumbai, no matter the distance."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Skyline Cabs drivers are experienced, professional, and familiar with the best routes from Katraj to Mumbai. They are courteous, background-checked, and dedicated to making your journey safe, smooth, and enjoyable from start to finish."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers affordable rates for your Katraj to Mumbai cab service. Our pricing is transparent, with no hidden fees, and we provide upfront fare estimates. You'll always know the cost before your journey begins, making budgeting easier and stress-free."
    },
    {
        "WhyChooseheading": "24/7 Availability for Anytime Travel",
        "WhyChoosedescription": "Our Katraj to Mumbai cab service is available 24/7, so you can book a ride at any time of day or night. Whether it's an early morning flight or a late-night business trip, we ensure that you have a comfortable and reliable ride whenever you need it."
    },
    {
        "WhyChooseheading": "Tailored Vehicles for Every Group Size",
        "WhyChoosedescription": "Whether you're traveling solo or in a group, Skyline Cabs offers the perfect vehicle for your journey. Our fleet includes sedans for solo travelers, spacious SUVs for family groups, and premium cars for those seeking luxury travel."
    },
    {
        "WhyChooseheading": "Easy Booking with Instant Confirmation",
        "WhyChoosedescription": "Booking a cab from Katraj to Mumbai is simple and quick with Skyline Cabs. Use our easy-to-navigate website or mobile app to book your ride, receive instant confirmation, and track your cab in real-time for a seamless travel experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Guaranteed",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are GPS-equipped for live tracking, and our drivers undergo thorough background checks. With Skyline Cabs, you can rest assured that you’re in safe hands during your entire journey from Katraj to Mumbai."
    }
]

















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Katraj to Mumbai with Skyline Cabs?',
            answer:
                'Booking your ride is easy! You can book through our website or mobile app. Simply enter Katraj as your pickup location, Mumbai as your destination, and choose the vehicle that best fits your needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Katraj to Mumbai?',
            answer:
                'We offer a range of vehicles including sedans, SUVs, Innova Crysta, Ertiga, and premium options. Select the vehicle that suits your comfort and space preferences during the booking process.',
        },
        {
            id: 3,
            question: 'Is the fare for a Katraj to Mumbai ride fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed, transparent pricing. The fare includes tolls, taxes, and driver charges — no hidden costs or surprises. You’ll know the total fare upfront.',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Katraj to Mumbai?',
            answer:
                'Yes, you can book both one-way and round-trip rides. Just provide your return details when booking, and we’ll ensure everything is taken care of.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Katraj to Mumbai?',
            answer:
                'The journey from Katraj to Mumbai typically takes around 3.5 to 4 hours, depending on traffic conditions. Our drivers are experienced in navigating the best routes for a timely arrival.',
        },
        {
            id: 6,
            question: 'Are your drivers experienced with the Katraj to Mumbai route?',
            answer:
                'Yes, all our drivers are trained, background-verified, and familiar with the route. They ensure a safe, smooth, and timely journey from Katraj to Mumbai.',
        },
        {
            id: 7,
            question: 'Can I book a cab for an airport transfer from Katraj to Mumbai?',
            answer:
                'Yes, Skyline Cabs offers reliable airport transfer services to Mumbai’s Domestic and International airports. We’ll ensure that you arrive at the airport on time and with ease.',
        },
        {
            id: 8,
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer:
                'Absolutely! All of our cabs are fully air-conditioned and well-maintained for your comfort. We prioritize cleanliness, hygiene, and a pleasant ride experience for all our passengers.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my booking after confirmation?',
            answer:
                'Yes, we offer a flexible cancellation and modification policy. You can modify or cancel your booking through our website, mobile app, or by contacting our customer support team.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Katraj to Mumbai trip?',
            answer:
                'Skyline Cabs provides competitive prices, a variety of vehicle options, and a professional team. We ensure timely service, well-maintained vehicles, and a smooth, stress-free ride from Katraj to Mumbai.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rajesh Kumar",
            rating: 5,
            review: "I booked a cab for a trip from Katraj to Mumbai. The vehicle was clean, the driver was polite and professional, and the journey was smooth. I will definitely use Skyline Cabs again for my future travels."
        },
        {
            name: "Miss. Neha Patil",
            rating: 4,
            review: "The ride from Katraj to Mumbai was very comfortable. The driver was punctual, and the car was well-maintained. The only thing I would suggest is better communication regarding exact arrival time, but overall, a great experience."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Katraj to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/katraj-to-mumbai-cab.jpg",
  "description": "Book Katraj to Mumbai cab service with Skyline Cabs for safe, reliable, and affordable travel. Enjoy 24/7 availability of AC sedans and SUVs with professional drivers for one-way or round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7475"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/katraj-to-mumbai-cab-service"
  }
};



      
     
      


    return (
        <div>

<Helmet>
  <title>Katraj to Mumbai Cab Service | AC Cabs & 24/7 Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Katraj to Mumbai cab service with Skyline Cabs for safe, reliable, and affordable travel. Enjoy 24/7 availability of AC sedans and SUVs with professional drivers for one-way or round-trip journeys." 
  />
  <meta 
    name="keywords" 
    content="Katraj to Mumbai Cab Service, Cab from Katraj to Mumbai, One-Way Taxi Katraj to Mumbai, Round Trip Cab Katraj to Mumbai, AC Cab Katraj to Mumbai, SUV Taxi Katraj to Mumbai, 24/7 Cab Booking Katraj to Mumbai, Online Taxi Katraj to Mumbai, Affordable Cabs Katraj to Mumbai, Skyline Cabs Katraj to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Katrajtomumbaicab;